import React, { useState, useEffect } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { Formik, Form, ErrorMessage, Field } from "formik";
import MainButton from "../../../shared/Button";
import { isValidPhoneNumber } from "react-phone-number-input";
import CommonPhoneInputs from "../../../shared/authinput/CommonPhoneInputs";
import {
  CustomLabel,
  PhoneInputsMain,
} from "../../../shared/commonstyle/PhoneStyle";
import {
  // DetailFormMain,
  // UserAvatar,
  // CameraButton,
  // UserAvatarMian,
  // DetailHeader,
  // UserInfo,
  FormPart,
} from "../../../admin/customer/styles/DetailFormStyles";
import AuthInput from "../../../shared/authinput";
import { toast } from "react-hot-toast";
import httpRequest from "../../../../axios/index";
import { PRICEPLAN, USERINFO } from "../../../../constants/apiEndPoints";
import {
  FormMain,
  CameraButton,
  UserAvatar,
  UserAvatarMian,
  EditProfileMian,
} from "../styles/EditProfileStyle";
import Loader from "../../../shared/loader";
import { EditProfilevalidation } from "../../../../helpers/validations/Auth";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../../../redux/slice/user/UserSlice";

const EditProfile = () => {
  const UserInformation = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [BtnLoading, setBtnLoading] = useState(false);
  const [ImageUrl, setImageUrl] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [UserInfo, setUserInfo] = useState([]);
  const [PhoneError, SetPhoneError] = useState(false);
  const [customerType, setCustomerType] = useState("");
  // const [PaymentFrequency, setPaymentFrequency] = useState([]);
  const [FrequencyType, setFrequencyType] = useState(null);
  const [UploadFile, setUploadFile] = useState(null);
  const [userImage, setuserImage] = useState(false);

  const handleCustomerTypeChange = (event) => {
    // if (event.target.value === "business") {
    //   GetPricePlan();
    // }
    setCustomerType(event.target.value);
  };
  // const handlePaymentFrequency = (event) => {
  //   setFrequencyType(event.target.value);
  // };

  // const GetPricePlan = async () => {
  //   try {
  //     const resp = await httpRequest.get(PRICEPLAN);
  //     if (resp?.status === 200) {
  //       if (resp?.data?.message === "Success") {
  //         setPaymentFrequency(resp?.data?.data);
  //       }
  //     }
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || "Something went wrong");
  //   }
  // };

  // useEffect(() => {
  //   if (customerType === "business") {
  //     GetPricePlan();
  //   }
  // }, [customerType]);

  const initials = UserInfo.name
    ?.split(" ")
    .map((name) => name.charAt(0))
    .join("");

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSizeInBytes = 2097152; // 1MB

    if (file) {
      // Check file type
      if (!allowedTypes.includes(file.type)) {
        toast.error(
          "Invalid file type. Please select a PNG, JPG, or JPEG file."
        );
        return;
      }

      // Check file size
      if (file.size > maxSizeInBytes) {
        toast.error(
          "File size exceeds the limit. Please select a file up to 2MB in size."
        );

        return;
      }
      setUploadFile(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setuserImage(reader);
        setImageUrl(reader.result);
      };
    }
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();
    const { phoneNumber } = values;

    if (
      phoneNumber !== undefined &&
      phoneNumber !== "" &&
      phoneNumber !== "+null"
    ) {
      SetPhoneError(false);
      const isValid = isValidPhoneNumber(phoneNumber);
      if (!isValid) {
        SetPhoneError(true);
        return;
      }
    }

    try {
      setBtnLoading(true);

      if (UploadFile) {
        formData.append("user[profile_image]", UploadFile);
      }
      formData.append("user[name]", values.FullName);
      formData.append("user[user_type]", customerType);
      formData.append("user[company_name]", values.CompanyName);
      if (
        phoneNumber !== undefined &&
        phoneNumber !== "" &&
        phoneNumber !== "+null"
      ) {
        formData.append("user[phone_number]", phoneNumber);
      }
      if (customerType !== "regular") {
        formData.append("user[price_plan_id]", FrequencyType);
      }
      if (values.email) {
        formData.append("user[email]", values.email);
      }
      const resp = await httpRequest.patch(USERINFO, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          setUserInfo(resp?.data?.user);
          setCustomerType(resp?.data?.user?.user_type);
          setFrequencyType(resp?.data?.user?.price_plan?.id);
          toast.success("Successfully Updated");
          const userToken = { auth_token: UserInformation?.user?.auth_token };
          const UserData = { ...resp?.data?.user, ...userToken };
          dispatch(loginSuccess(UserData));
        }
      }
      setBtnLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setBtnLoading(false);
    }
  };

  const handleChange = (value, event, form) => {
    // SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }
    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
  };

  useEffect(() => {
    GetUserInfo();
  }, []);

  const GetUserInfo = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.get(USERINFO);
      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          setUserInfo(resp?.data?.user);
          setCustomerType(resp?.data?.user?.user_type);
          setFrequencyType(resp?.data?.user?.price_plan?.id);
          setuserImage(true);
          setImageUrl(resp?.data?.user?.profile_image_url);
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const initialValues = {
    FullName: UserInfo?.name || "",
    CompanyName: UserInfo?.company_name || "",
    email: UserInfo?.email || "",
    phoneNumber: UserInfo?.phone_number ? "+" + UserInfo?.phone_number : "",
  };

  return (
    // <ProfileLayout>
    <EditProfileMian>
      {Loading && <Loader />}
      {!Loading && (
        <>
          <UserAvatarMian className="UserAvatarMian">
            {userImage ? (
              <UserAvatar alt={ImageUrl} src={ImageUrl} />
            ) : (
              <UserAvatar alt="UserName">{initials}</UserAvatar>
            )}

            <CameraButton component="label" htmlFor="avatar-upload">
              <CameraAltIcon />
              <input
                id="avatar-upload"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
            </CameraButton>
          </UserAvatarMian>
          {/* inputs */}
          <FormMain>
            <FormPart>
              <Formik
                initialValues={initialValues}
                validationSchema={EditProfilevalidation}
                onSubmit={handleSubmit}
              >
                {(formik) => (
                  <Form autocomplete="off">
                    <div className="FormItem">
                      <Field
                        type="text"
                        name="FullName"
                        label="Full Name"
                        component={AuthInput}
                        placeholder="Enter your Full Name"
                      />
                    </div>
                    <div className="FormItem">
                      {customerType !== "regular" && (
                        <Field
                          type="text"
                          name="CompanyName"
                          label="Company Name"
                          component={AuthInput}
                          placeholder="Enter your Company Name"
                        />
                      )}
                      <div className="CustomerTypeMain">
                        <CustomLabel>Customer Type</CustomLabel>
                        <select
                          value={customerType}
                          onChange={handleCustomerTypeChange}
                          disabled
                        >
                          <option value="business">Business</option>
                          <option value="regular">Regular </option>
                        </select>
                      </div>
                    </div>

                    <div
                      className={`FormItem havePhone ${
                        UserInfo && UserInfo?.phone_number !== null
                          ? "profile_phone"
                          : ""
                      }`}
                    >
                      <PhoneInputsMain
                        className={`PhoneInputsMain ${
                          formik.touched.phoneNumber &&
                          formik.errors.phoneNumber &&
                          "is__error"
                        }`}
                      >
                        <CustomLabel>Phone Number</CustomLabel>
                        <Field name="phoneNumber">
                          {({ field, form }) => (
                            <CommonPhoneInputs
                              {...field}
                              isDisable={
                                UserInfo && UserInfo?.phone_number !== null
                              }
                              onChange={(value, event) =>
                                handleChange(value, event, form)
                              }
                            />
                          )}
                        </Field>
                        <ErrorMessage
                          name="phoneNumber"
                          component="span"
                          className="error"
                        />
                      </PhoneInputsMain>
                      <Field
                        type="email"
                        name="email"
                        label="Email Address"
                        component={AuthInput}
                        placeholder="Enter your Email Address"
                        readOnly={UserInfo && UserInfo?.email ? true : false}
                      />
                    </div>

                    {/* {customerType === "business" && (
                      <div className="FormItem ">
                        <div className="CustomerTypeMain">
                          <CustomLabel>Payment Frequency</CustomLabel>
                          <select
                            value={FrequencyType}
                            onChange={handlePaymentFrequency}
                          >
                            {PaymentFrequency &&
                              PaymentFrequency.length > 0 &&
                              PaymentFrequency?.map((value) => {
                                return (
                                  <>
                                    <option value={value?.id} key={value?.id}>
                                      {value?.name} ({value?.interval} Days)
                                    </option>
                                  </>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    )} */}

                    {PhoneError && (
                      <span
                        className="Phoneerror"
                        style={{ paddingLeft: "10px", color: "red" }}
                      >
                        Invalid phone number
                      </span>
                    )}
                    <MainButton
                      type="submit"
                      label="Save Changes"
                      MT="100"
                      isLoading={BtnLoading}
                    />
                  </Form>
                )}
              </Formik>
            </FormPart>
          </FormMain>
          {/* inputs */}
        </>
      )}
    </EditProfileMian>
    // </ProfileLayout>
  );
};

export default EditProfile;
